export const DShadowImpl = wcardinal.ui.DShadowImpl;